// extracted by mini-css-extract-plugin
module.exports = {"section":"fRAT876duszo5v461RXmoA==","heroImg":"qB3wg23q6V+JzIwJuoIp5A=="};